import Vue from 'vue'
import Vuex from 'vuex'
import global from './modules/global'
import project from './modules/project'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    global,
    project
  }
})
